__turbopack_context__.v({
  "className": "oZHZ1W_className",
  "variable": "oZHZ1W_variable",
});
